import { Modal } from "react-bootstrap";
import { HiCheckCircle, HiXCircle } from "react-icons/hi"; // Optional: for visual cues

const ROLES_DATA = [
    // {
    //     title: "Owner",
    //     description: "Full administrative authority. Owners have complete control over all organizational assets, billing, and team management.",
    //     permissions: [
    //         "Organization management",
    //         "Member management (add, remove, update roles)",
    //         "Access to Simple & Developer Playground",
    //         "LLM Configuration & Assignment",
    //         "Model Fine-tuning",
    //         "Agent Builder",
    //         "Create workflows & automations",
    //         "View usage analytics",
    //         "View audit logs"
    //     ]
    // },
    {
        title: "Manager",
        description: "Focuses on team operations and administrative tasks. Ideal for personnel leads who don't manage technical model configurations.",
        permissions: [
            "Member management (add, remove, update roles)",
            "Access to Simple Playground",
            "Create workflows & automations",
            "View usage analytics",
            "View audit logs"
        ],
    },
    {
        title: "Developer",
        description: "Technical access for building and optimizing. Developers can manage the entire AI lifecycle but cannot manage the team.",
        permissions: [
            "Access to Simple & Developer Playground",
            "LLM Configuration & Assignment",
            "Model Fine-tuning",
            "Agent Builder",
            "Create workflows & automations",
            "View usage analytics",
            "View audit logs"
        ],
    },
    {
        title: "Member",
        description: "Standard access level for end-users to utilize existing tools and build personal workflows.",
        permissions: [
            "Access to Simple Playground",
            "Create workflows & automations",
            "View usage analytics",
            "View audit logs"
        ],
    }
];

const RoleModal = ({ show, handleClose }) => {
    return (
        <Modal show={show} onHide={handleClose} centered className="role_modal">
            <div className="modal_header">
                <p className="modal_header_title">Roles and Permissions</p>
            </div>

            <div className="modal_main_cont">
                <div className="role_list_container">
                    {ROLES_DATA.map((role, index) => (
                        <div key={index} className="role_perm_section">
                            <div className="role_perm_desc_cont">
                                <p className="role_perm_title">{role.title}</p>
                                <p className="role_perm_description">{role.description}</p>
                            </div>
                            
                            <div className="role_access_list">
                                <p className="access_list_label">Access Includes:</p>
                                <div className="permissions_grid">
                                    {role.permissions.map((perm, pIdx) => (
                                        <div key={pIdx} className="perm_item">
                                            <HiCheckCircle className="icon_check" /> {perm}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {index !== ROLES_DATA.length - 1 && <hr className="role_divider" />}
                        </div>
                    ))}
                </div>
            </div>

            <div className="modal_footer">
                <p></p>
                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default RoleModal;